const ErrorPage = () => {
  return (
    <section className="bg-white">
      <div className="container vertical-center min-h-screen px-6 py-12 mx-auto">
        <div className="vertical-center flex-col max-w-sm mx-auto text-center">
          <p className="p-3 text-sm font-medium text-secondary-dark rounded-full bg-secondary/10">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          </p>
          <h1 className="mt-3 text-2xl font-semibold text-grey md:text-3xl">Page not found</h1>
          <p className="mt-4 text-mediumgrey">The page you are looking for doesn&apos;t exist.</p>
        </div>
      </div>
    </section>
  )
}

export default ErrorPage
